import React, { useState, useEffect } from 'react';
import axios from 'axios';

// client/src/pages/Settings.js'in "Entegrasyonlar" (satır ~734-1104) ve
// "Ritsa Asist" (satır ~1107-1182) sekmelerinin admin paneline taşınmış hali.
// Aynı `branches.integrations` JSON kolonunu okuyup yazıyor - backend'e (branches.js,
// integrations.js) HİÇBİR DOKUNUŞ YOK, sadece admin "impersonation mount" path'i
// (server/middleware/adminImpersonateBranch.js) üzerinden erişiliyor.
const DEFAULT_INTEGRATIONS = {
  sms_provider: 'netgsm',
  netgsm_user: '',
  netgsm_pass: '',
  netgsm_title: '',
  waha_url: '',
  waha_api_key: '',
  waha_session: 'default',
  elevenlabs_api_key: '',
  elevenlabs_webhook_secret: '',
  smtp_host: '',
  smtp_port: '587',
  smtp_user: '',
  smtp_pass: '',
  smtp_from: '',
  smtp_secure: 'tls',
  salonappy_phone: '',
  salonappy_password: '',
  owner_notification_phone: '',
  owner_daily_summary_enabled: true,
  owner_daily_summary_time: '21:00'
};

const IntegrationsPanel = ({ branchId, showToast }) => {
  const [section, setSection] = useState('integrations');
  const [branch, setBranch] = useState(null);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [toolsSecretVisible, setToolsSecretVisible] = useState(false);

  const [salonappyTesting, setSalonappyTesting] = useState(false);
  const [salonappyTestResult, setSalonappyTestResult] = useState(null);
  const [salonappyMonths, setSalonappyMonths] = useState(12);
  const [salonappyJob, setSalonappyJob] = useState(null);

  const [ownerAssistantTesting, setOwnerAssistantTesting] = useState(false);
  const [ownerAssistantTestResult, setOwnerAssistantTestResult] = useState(null);

  // 2. WhatsApp hesabı desteği: WAHA ayarları artık ai_webhooks üzerinden çoklu
  // hesap olarak yönetiliyor (bkz. server/routes/integrations.js whatsapp-accounts
  // uçları) - branches.integrations.waha_* eski/tek-hesaplı alanları bir kereye
  // mahsus bu listeye taşınmıştı (server/db/connection.js migration), artık bu
  // ekran onlara hiç dokunmuyor.
  const [waAccounts, setWaAccounts] = useState([]);
  const [waLoading, setWaLoading] = useState(true);
  const [waForm, setWaForm] = useState(null); // null = kapalı, {} = yeni, {...account} = düzenleme
  const [waSaving, setWaSaving] = useState(false);

  // KVKK: firmanın kendi veritabanına müşteri verisi senkronizasyonu (bkz.
  // externalDataSyncWorker.js). target_password GET'te asla dönmeyeceği için
  // form her açılışta boş başlar - sadece yeni bir değer girilirse güncellenir.
  const [dataSyncSettings, setDataSyncSettings] = useState(null);
  const [dataSyncForm, setDataSyncForm] = useState({ is_enabled: false, target_host: '', target_port: 3306, target_database: '', target_username: '', target_password: '', target_table: 'customers' });
  const [dataSyncLoading, setDataSyncLoading] = useState(true);
  const [dataSyncSaving, setDataSyncSaving] = useState(false);
  const [dataSyncTestResult, setDataSyncTestResult] = useState(null);
  const [dataSyncTesting, setDataSyncTesting] = useState(false);
  const [dataSyncBackfilling, setDataSyncBackfilling] = useState(false);
  const [dataSyncLogs, setDataSyncLogs] = useState([]);

  const token = () => localStorage.getItem('admin_token');
  const headers = () => ({ Authorization: `Bearer ${token()}` });
  const branchBase = `/api/admin/branches/${branchId}/branch`;
  const integrationsBase = `/api/admin/branches/${branchId}/integrations`;

  useEffect(() => { fetchBranch(); fetchWaAccounts(); fetchDataSyncSettings(); fetchDataSyncLogs(); }, [branchId]);

  const dataSyncBase = `/api/admin/branches/${branchId}/data-sync-settings`;

  const fetchDataSyncSettings = async () => {
    setDataSyncLoading(true);
    try {
      const { data } = await axios.get(dataSyncBase, { headers: headers() });
      setDataSyncSettings(data.settings);
      if (data.settings) {
        setDataSyncForm({
          is_enabled: !!data.settings.is_enabled,
          target_host: data.settings.target_host || '',
          target_port: data.settings.target_port || 3306,
          target_database: data.settings.target_database || '',
          target_username: data.settings.target_username || '',
          target_password: '', // güvenlik gereği asla dönmüyor
          target_table: data.settings.target_table || 'customers'
        });
      }
    } catch (e) { console.error(e); }
    finally { setDataSyncLoading(false); }
  };

  const fetchDataSyncLogs = async () => {
    try {
      const { data } = await axios.get(`${dataSyncBase.replace('data-sync-settings', 'data-sync-logs')}`, { headers: headers() });
      setDataSyncLogs(data.logs || []);
    } catch (e) { console.error(e); }
  };

  const handleDataSyncChange = (field, val) => setDataSyncForm(prev => ({ ...prev, [field]: val }));

  const handleDataSyncSave = async () => {
    setDataSyncSaving(true);
    try {
      await axios.put(dataSyncBase, dataSyncForm, { headers: headers() });
      showToast ? showToast('✅ Veri senkronizasyon ayarları kaydedildi!', 'success') : alert('Kaydedildi!');
      fetchDataSyncSettings();
    } catch (e) {
      const msg = e.response?.data?.error || e.message;
      showToast ? showToast('❌ ' + msg, 'error') : alert('Hata: ' + msg);
    } finally { setDataSyncSaving(false); }
  };

  const handleDataSyncTest = async () => {
    setDataSyncTesting(true);
    setDataSyncTestResult(null);
    try {
      const { data } = await axios.post(`${dataSyncBase}/test-connection`, dataSyncForm, { headers: headers() });
      setDataSyncTestResult(data.success ? { ok: true, message: data.message } : { ok: false, message: data.error });
    } catch (e) {
      setDataSyncTestResult({ ok: false, message: e.response?.data?.error || e.message });
    } finally { setDataSyncTesting(false); }
  };

  const handleDataSyncBackfill = async () => {
    if (!window.confirm('Bu şubenin TÜM mevcut müşterileri bir sonraki tur içinde hedef veritabanına yeniden gönderilecek. Devam edilsin mi?')) return;
    setDataSyncBackfilling(true);
    try {
      await axios.post(`${dataSyncBase}/backfill`, {}, { headers: headers() });
      showToast ? showToast('✅ Tam senkron tetiklendi', 'success') : alert('Tetiklendi!');
      fetchDataSyncSettings();
    } catch (e) {
      const msg = e.response?.data?.error || e.message;
      showToast ? showToast('❌ ' + msg, 'error') : alert('Hata: ' + msg);
    } finally { setDataSyncBackfilling(false); }
  };

  const fetchWaAccounts = async () => {
    setWaLoading(true);
    try {
      const { data } = await axios.get(`${integrationsBase}/whatsapp-accounts`, { headers: headers() });
      setWaAccounts(data || []);
    } catch (e) { console.error(e); }
    finally { setWaLoading(false); }
  };

  const handleWaSave = async () => {
    setWaSaving(true);
    try {
      if (waForm.id) {
        await axios.put(`${integrationsBase}/whatsapp-accounts/${waForm.id}`, waForm, { headers: headers() });
      } else {
        await axios.post(`${integrationsBase}/whatsapp-accounts`, waForm, { headers: headers() });
      }
      showToast ? showToast('✅ WhatsApp hesabı kaydedildi!', 'success') : alert('Kaydedildi!');
      setWaForm(null);
      fetchWaAccounts();
    } catch (e) {
      const msg = e.response?.data?.error || e.message;
      showToast ? showToast('❌ ' + msg, 'error') : alert('Hata: ' + msg);
    } finally { setWaSaving(false); }
  };

  const handleWaRemove = async (id) => {
    if (!window.confirm('Bu WhatsApp hesabını kaldırmak istediğinize emin misiniz?')) return;
    try {
      await axios.delete(`${integrationsBase}/whatsapp-accounts/${id}`, { headers: headers() });
      showToast ? showToast('✅ Hesap kaldırıldı', 'success') : alert('Kaldırıldı');
      fetchWaAccounts();
    } catch (e) {
      const msg = e.response?.data?.error || e.message;
      showToast ? showToast('❌ ' + msg, 'error') : alert('Hata: ' + msg);
    }
  };

  useEffect(() => {
    if (!salonappyJob || !salonappyJob.running) return;
    const timer = setInterval(async () => {
      try {
        const { data } = await axios.get(`${integrationsBase}/salonappy/sync/status`, { headers: headers() });
        setSalonappyJob(data);
      } catch (e) { /* ignore transient poll errors */ }
    }, 2000);
    return () => clearInterval(timer);
  }, [salonappyJob]);

  const fetchBranch = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(`${branchBase}/`, { headers: headers() });
      const rawBranch = Array.isArray(data) ? data[0] : data;
      if (rawBranch) {
        let integrations = DEFAULT_INTEGRATIONS;
        if (rawBranch.integrations) {
          try {
            const parsed = typeof rawBranch.integrations === 'string' ? JSON.parse(rawBranch.integrations) : rawBranch.integrations;
            integrations = { ...DEFAULT_INTEGRATIONS, ...parsed };
          } catch (e) { integrations = DEFAULT_INTEGRATIONS; }
        }
        setBranch({ ...rawBranch, integrations });
      }
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  const handleIntegrationChange = (field, val) => {
    setBranch(prev => ({ ...prev, integrations: { ...prev.integrations, [field]: val } }));
  };

  const handleSave = async () => {
    setSaving(true);
    try {
      await axios.put(`${branchBase}/${branchId}`, branch, { headers: headers() });
      showToast ? showToast('✅ Entegrasyon ayarları kaydedildi!', 'success') : alert('Kaydedildi!');
    } catch (e) {
      const msg = e.response?.data?.error || e.message;
      showToast ? showToast('❌ ' + msg, 'error') : alert('Hata: ' + msg);
    } finally { setSaving(false); }
  };

  const handleSalonappyTest = async () => {
    setSalonappyTesting(true);
    setSalonappyTestResult(null);
    try {
      const { data } = await axios.post(`${integrationsBase}/salonappy/test`, {
        phone: branch?.integrations?.salonappy_phone,
        password: branch?.integrations?.salonappy_password,
      }, { headers: headers() });
      setSalonappyTestResult({ ok: true, message: `Bağlantı başarılı: ${data.salon_title}` });
    } catch (e) {
      setSalonappyTestResult({ ok: false, message: e.response?.data?.error || 'Bağlantı başarısız' });
    } finally {
      setSalonappyTesting(false);
    }
  };

  const handleSalonappySync = async () => {
    try {
      await axios.post(`${integrationsBase}/salonappy/sync`, {
        phone: branch?.integrations?.salonappy_phone,
        password: branch?.integrations?.salonappy_password,
        months: salonappyMonths,
      }, { headers: headers() });
      setSalonappyJob({ running: true, phase: 'starting', imported: { customers: 0, appointments: 0 }, errors: [] });
    } catch (e) {
      setSalonappyTestResult({ ok: false, message: e.response?.data?.error || 'Aktarım başlatılamadı' });
    }
  };

  const handleOwnerAssistantTest = async () => {
    setOwnerAssistantTesting(true);
    setOwnerAssistantTestResult(null);
    try {
      await axios.post(`${integrationsBase}/owner-assistant/test`, {}, { headers: headers() });
      setOwnerAssistantTestResult({ ok: true, message: 'Test mesajı gönderildi, WhatsApp\'ı kontrol edin.' });
    } catch (e) {
      setOwnerAssistantTestResult({ ok: false, message: e.response?.data?.error || 'Test mesajı gönderilemedi' });
    } finally {
      setOwnerAssistantTesting(false);
    }
  };

  if (loading) return <div className="loading"><div className="loading-spinner"></div></div>;
  if (!branch) return <div style={{ color: 'var(--text-secondary)' }}>Şube bilgisi yüklenemedi.</div>;

  return (
    <div>
      <div style={{ display: 'flex', gap: 8, marginBottom: 20 }}>
        <button className={`btn ${section === 'integrations' ? 'btn-primary' : 'btn-secondary'}`} onClick={() => setSection('integrations')}>🔌 Entegrasyon Ayarları</button>
        <button className={`btn ${section === 'owner_assistant' ? 'btn-primary' : 'btn-secondary'}`} onClick={() => setSection('owner_assistant')}>🤖 Ritsa Asist</button>
        <button className={`btn ${section === 'data_sync' ? 'btn-primary' : 'btn-secondary'}`} onClick={() => setSection('data_sync')}>🔒 Veri Senkronizasyonu</button>
      </div>

      {section === 'integrations' && (
        <div className="card glass-card">
          <div className="card-header-icon">
            <span className="icon-badge">🔌</span>
            <h3 className="card-title">Entegrasyon Ayarları</h3>
          </div>
          <p className="card-subtitle-desc">WhatsApp, SMS sağlayıcıları ve E-posta SMTP geçidi ayarlarını yapın.</p>

          <div className="integration-sections">
            <div className="integration-group">
              <h4 className="int-title">💬 SMS Gateway Ayarları</h4>
              <div className="grid-2">
                <div className="form-group">
                  <label className="form-label">Sağlayıcı</label>
                  <select className="select" value={branch?.integrations?.sms_provider || 'netgsm'} onChange={e => handleIntegrationChange('sms_provider', e.target.value)}>
                    <option value="netgsm">Netgsm</option>
                    <option value="smsvitrini">Sms Vitrini</option>
                  </select>
                </div>
                <div className="form-group">
                  <label className="form-label">Gönderici Başlığı (Header)</label>
                  <input type="text" className="input" value={branch?.integrations?.netgsm_title || ''} onChange={e => handleIntegrationChange('netgsm_title', e.target.value)} placeholder="NETGSM" />
                </div>
              </div>
              <div className="grid-2">
                <div className="form-group">
                  <label className="form-label">Kullanıcı Adı</label>
                  <input type="text" className="input" value={branch?.integrations?.netgsm_user || ''} onChange={e => handleIntegrationChange('netgsm_user', e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="form-label">Şifre</label>
                  <input type="password" className="input" value={branch?.integrations?.netgsm_pass || ''} onChange={e => handleIntegrationChange('netgsm_pass', e.target.value)} />
                </div>
              </div>
            </div>

            <div className="integration-group mt-20">
              <h4 className="int-title">✉️ SMTP E-posta Ayarları</h4>
              <div className="grid-3">
                <div className="form-group">
                  <label className="form-label">SMTP Sunucusu</label>
                  <input type="text" className="input" value={branch?.integrations?.smtp_host || ''} onChange={e => handleIntegrationChange('smtp_host', e.target.value)} placeholder="smtp.yandex.com" />
                </div>
                <div className="form-group">
                  <label className="form-label">Port</label>
                  <input type="text" className="input" value={branch?.integrations?.smtp_port || '587'} onChange={e => handleIntegrationChange('smtp_port', e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="form-label">Güvenlik</label>
                  <select className="select" value={branch?.integrations?.smtp_secure || 'tls'} onChange={e => handleIntegrationChange('smtp_secure', e.target.value)}>
                    <option value="tls">TLS</option>
                    <option value="ssl">SSL</option>
                    <option value="none">Yok</option>
                  </select>
                </div>
              </div>
              <div className="grid-3">
                <div className="form-group">
                  <label className="form-label">Gönderici E-postası</label>
                  <input type="email" className="input" value={branch?.integrations?.smtp_from || ''} onChange={e => handleIntegrationChange('smtp_from', e.target.value)} placeholder="info@ornek.com" />
                </div>
                <div className="form-group">
                  <label className="form-label">SMTP Kullanıcı</label>
                  <input type="text" className="input" value={branch?.integrations?.smtp_user || ''} onChange={e => handleIntegrationChange('smtp_user', e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="form-label">SMTP Şifre</label>
                  <input type="password" className="input" value={branch?.integrations?.smtp_pass || ''} onChange={e => handleIntegrationChange('smtp_pass', e.target.value)} />
                </div>
              </div>
            </div>

            <div className="integration-group mt-20">
              <h4 className="int-title">📱 WhatsApp Entegrasyonu</h4>
              <p style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 16 }}>
                İki bağlantı türünden biriyle mesajları CRM'e bağlayın — hangisi bağlıysa o
                kullanılır, aynı şubede WAHA ve Resmi API karışık da olabilir. Birden fazla hat
                (ör. ana hat + kampanya hattı) ekleyebilirsiniz.<br />
                <strong>WAHA</strong> webhook URL'i: <code style={{ background: 'rgba(255,255,255,0.08)', padding: '2px 6px', borderRadius: 4, fontSize: 12 }}>https://crm.ritsaai.com/webhook/waha/{branchId}</code><br />
                <strong>Resmi API</strong> webhook URL'i: <code style={{ background: 'rgba(255,255,255,0.08)', padding: '2px 6px', borderRadius: 4, fontSize: 12 }}>https://crm.ritsaai.com/webhook/whatsapp/{branchId}</code>
              </p>

              {waLoading ? (
                <div style={{ color: 'var(--text-muted)', fontSize: 13 }}>Yükleniyor...</div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginBottom: 14 }}>
                  {waAccounts.map(acc => (
                    <div key={acc.id} style={{ display: 'flex', flexDirection: 'column', gap: 6, padding: '10px 14px', borderRadius: 10, background: 'rgba(255,255,255,0.03)', border: '1px solid var(--border)' }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
                          <span className={`badge ${acc.is_active ? 'badge-success' : 'badge-secondary'}`} style={{ padding: '5px 10px', flexShrink: 0 }}>
                            {acc.is_active ? 'Aktif' : 'Pasif'}
                          </span>
                          <span className="badge" style={{ padding: '5px 10px', flexShrink: 0, background: acc.provider === 'official' ? 'rgba(96,165,250,0.15)' : 'rgba(52,211,153,0.15)', color: acc.provider === 'official' ? '#60A5FA' : '#34D399' }}>
                            {acc.provider === 'official' ? 'Resmi API' : 'WAHA'}
                          </span>
                          <span style={{ fontSize: 13, color: 'var(--text)', fontWeight: 600, whiteSpace: 'nowrap' }}>
                            {acc.label || `Hesap ${acc.id}`}
                          </span>
                          <span style={{ fontSize: 12, color: 'var(--text-muted)', overflow: 'hidden', textOverflow: 'ellipsis' }}>
                            {acc.provider === 'official' ? `phone_number_id: ${acc.waha_session}` : `session: ${acc.waha_session}`}
                          </span>
                        </div>
                        <div style={{ display: 'flex', gap: 6, flexShrink: 0 }}>
                          <button type="button" className="btn btn-secondary" onClick={() => setWaForm({ ...acc, wa_phone_number_id: acc.waha_session, wa_access_token: '', wa_app_secret: '' })}>Düzenle</button>
                          <button type="button" className="btn btn-secondary" onClick={() => handleWaRemove(acc.id)}>Kaldır</button>
                        </div>
                      </div>
                      {acc.provider === 'official' && acc.verify_token && (
                        <div style={{ fontSize: 11, color: 'var(--text-muted)' }}>
                          Meta webhook doğrulama token'ı: <code style={{ background: 'rgba(255,255,255,0.08)', padding: '2px 6px', borderRadius: 4 }}>{acc.verify_token}</code>
                        </div>
                      )}
                    </div>
                  ))}
                  {waAccounts.length === 0 && (
                    <div style={{ color: 'var(--text-muted)', fontSize: 13, fontStyle: 'italic' }}>Henüz bağlı bir WhatsApp hattı yok.</div>
                  )}
                </div>
              )}

              {waForm ? (
                <div style={{ padding: 14, borderRadius: 10, background: 'rgba(255,255,255,0.02)', border: '1px solid var(--border)' }}>
                  <div className="grid-2">
                    <div className="form-group">
                      <label className="form-label">Etiket</label>
                      <input type="text" className="input" value={waForm.label || ''} onChange={e => setWaForm({ ...waForm, label: e.target.value })} placeholder="Ana Hat, Kampanya Hattı..." />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Bağlantı Türü</label>
                      <select className="select" value={waForm.provider || 'waha'} onChange={e => setWaForm({ ...waForm, provider: e.target.value })} disabled={!!waForm.id}>
                        <option value="waha">WAHA (kendi sunucunuz)</option>
                        <option value="official">Resmi WhatsApp Business API</option>
                      </select>
                    </div>
                  </div>

                  {waForm.provider === 'official' ? (
                    <>
                      <div className="grid-2">
                        <div className="form-group">
                          <label className="form-label">Telefon Numarası ID (phone_number_id)</label>
                          <input type="text" className="input" value={waForm.wa_phone_number_id || ''} onChange={e => setWaForm({ ...waForm, wa_phone_number_id: e.target.value })} placeholder="1098..." />
                        </div>
                        <div className="form-group">
                          <label className="form-label">Erişim Token (Access Token)</label>
                          <input type="password" className="input" value={waForm.wa_access_token || ''} onChange={e => setWaForm({ ...waForm, wa_access_token: e.target.value })} placeholder={waForm.id ? 'Değiştirmek için doldurun' : 'EAABw...'} />
                        </div>
                      </div>
                      <div className="grid-2">
                        <div className="form-group">
                          <label className="form-label">App Secret</label>
                          <input type="password" className="input" value={waForm.wa_app_secret || ''} onChange={e => setWaForm({ ...waForm, wa_app_secret: e.target.value })} placeholder={waForm.id ? 'Değiştirmek için doldurun' : 'Meta App gizli anahtarı'} />
                        </div>
                      </div>
                      <p style={{ fontSize: 12, color: 'var(--text-muted)' }}>
                        Meta Developer Console'da webhook URL'i olarak yukarıdaki "Resmi API" adresini,
                        doğrulama token'ı olarak da kayıttan sonra hesap satırında görünecek token'ı girin.
                      </p>
                    </>
                  ) : (
                    <>
                      <div className="grid-2">
                        <div className="form-group">
                          <label className="form-label">WAHA Oturum Adı (Session)</label>
                          <input type="text" className="input" value={waForm.waha_session || ''} onChange={e => setWaForm({ ...waForm, waha_session: e.target.value })} placeholder="default" />
                        </div>
                        <div className="form-group">
                          <label className="form-label">WAHA API URL</label>
                          <input type="text" className="input" value={waForm.waha_url || ''} onChange={e => setWaForm({ ...waForm, waha_url: e.target.value })} placeholder="https://waha.ritsaai.com" />
                        </div>
                      </div>
                      <div className="grid-2">
                        <div className="form-group">
                          <label className="form-label">WAHA API Key</label>
                          <input type="password" className="input" value={waForm.waha_api_key || ''} onChange={e => setWaForm({ ...waForm, waha_api_key: e.target.value })} placeholder="Boş bırakırsanız key kullanılmaz" />
                        </div>
                      </div>
                    </>
                  )}

                  <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                    <button type="button" className="btn btn-primary" onClick={handleWaSave} disabled={waSaving}>{waSaving ? 'Kaydediliyor...' : '💾 Kaydet'}</button>
                    <button type="button" className="btn btn-secondary" onClick={() => setWaForm(null)}>Vazgeç</button>
                  </div>
                </div>
              ) : (
                <button type="button" className="btn btn-secondary" onClick={() => setWaForm({ provider: 'waha', waha_session: 'default' })}>+ Hesap Ekle</button>
              )}
            </div>

            <div className="integration-group mt-20">
              <h4 className="int-title">🎙️ ElevenLabs + Netgsm (Sesli Arama)</h4>
              <p style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 16 }}>
                Netgsm hattınızı ElevenLabs Conversational AI'a SIP Trunk ile bağladıktan sonra, ElevenLabs Agent'ınızın
                "Post-call webhook" ayarına aşağıdaki adresi girin:
                <br />
                Webhook URL: <code style={{ background: 'rgba(255,255,255,0.08)', padding: '2px 6px', borderRadius: 4, fontSize: 12 }}>
                  https://crm.ritsaai.com/webhook/elevenlabs/{branchId}
                </code>
                <br />
                Birden fazla ElevenLabs Agent'ınız varsa (örn. farklı dil/hizmet için), her birinin Agent ID / Phone Number ID
                bilgisini burada değil, <strong>AI Center &gt; AI Agentlar</strong> sekmesinde ilgili agent kartını düzenleyerek girin —
                aşağıdaki bilgiler tüm agent'ların ortak kullandığı hesap (API Key) ve webhook güvenlik bilgisidir.
              </p>
              <div className="grid-2">
                <div className="form-group">
                  <label className="form-label">ElevenLabs API Key</label>
                  <input type="password" className="input" value={branch?.integrations?.elevenlabs_api_key || ''} onChange={e => handleIntegrationChange('elevenlabs_api_key', e.target.value)} placeholder="xi-api-key" />
                </div>
                <div className="form-group">
                  <label className="form-label">Webhook Secret</label>
                  <input type="password" className="input" value={branch?.integrations?.elevenlabs_webhook_secret || ''} onChange={e => handleIntegrationChange('elevenlabs_webhook_secret', e.target.value)} placeholder="ElevenLabs post-call webhook secret'ı" />
                </div>
              </div>
              <div className="form-group" style={{ maxWidth: 560, marginTop: 12 }}>
                <label className="form-label">Sunucu Araçları (Tools) Secret'ı</label>
                <div style={{ display: 'flex', gap: 8 }}>
                  <input
                    type={toolsSecretVisible ? 'text' : 'password'}
                    className="input"
                    value={branch?.integrations?.elevenlabs_tools_secret || ''}
                    onChange={e => handleIntegrationChange('elevenlabs_tools_secret', e.target.value)}
                    placeholder="Sesli AI'nın canlı arama araçları için secret"
                  />
                  <button type="button" className="btn btn-secondary" onClick={() => setToolsSecretVisible(v => !v)}>
                    {toolsSecretVisible ? '🙈 Gizle' : '👁️ Göster'}
                  </button>
                  <button
                    type="button"
                    className="btn btn-secondary"
                    onClick={() => {
                      const val = branch?.integrations?.elevenlabs_tools_secret;
                      if (!val) return;
                      navigator.clipboard.writeText(val);
                      showToast ? showToast('✅ Kopyalandı!', 'success') : alert('Kopyalandı!');
                    }}
                  >
                    📋 Kopyala
                  </button>
                  <button type="button" className="btn btn-secondary" onClick={() => handleIntegrationChange('elevenlabs_tools_secret', Array.from(crypto.getRandomValues(new Uint8Array(24))).map(b => b.toString(16).padStart(2, '0')).join(''))}>
                    Üret
                  </button>
                </div>
                <span className="form-hint">
                  "Üret"e bastıktan sonra "👁️ Göster" ile değeri görebilir veya "📋 Kopyala" ile
                  doğrudan panoya alabilirsiniz — kaydetmeyi unutmayın. Bu değeri, AI Center &gt; AI
                  Agentlar'daki "🛠️ Sunucu Araçları" bölümünde gösterilen her tool için ElevenLabs'ta
                  "Custom Headers" alanına <code>X-Ritsa-Tools-Secret</code> olarak girin.
                </span>
              </div>
            </div>

            <div className="integration-group mt-20">
              <h4 className="int-title">💈 SalonAppy'den Aktarım</h4>
              <p style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 16 }}>
                SalonAppy hesabındaki müşteri ve randevu geçmişini bu şubeye aktarın. Bilgileri kaydedin, sonra istediğiniz an "Şimdi İçe Aktar" ile senkronize edin.
              </p>
              <div className="grid-2">
                <div className="form-group">
                  <label className="form-label">SalonAppy Telefon (Kullanıcı Adı)</label>
                  <input type="text" className="input" value={branch?.integrations?.salonappy_phone || ''} onChange={e => handleIntegrationChange('salonappy_phone', e.target.value)} placeholder="5xxxxxxxxx" />
                </div>
                <div className="form-group">
                  <label className="form-label">SalonAppy Şifre</label>
                  <input type="password" className="input" value={branch?.integrations?.salonappy_password || ''} onChange={e => handleIntegrationChange('salonappy_password', e.target.value)} />
                </div>
              </div>
              <div className="grid-2">
                <div className="form-group">
                  <label className="form-label">Randevu Geçmişi</label>
                  <select className="select" value={salonappyMonths} onChange={e => setSalonappyMonths(e.target.value === 'skip' ? 'skip' : parseInt(e.target.value, 10))}>
                    <option value={12}>Son 12 ay + gelecek randevular</option>
                    <option value={9999}>Tüm geçmiş</option>
                    <option value="skip">Sadece müşterileri aktar</option>
                  </select>
                </div>
              </div>
              <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap', marginTop: 8 }}>
                <button type="button" className="btn btn-secondary" onClick={handleSalonappyTest} disabled={salonappyTesting}>
                  {salonappyTesting ? 'Test ediliyor...' : 'Bağlantıyı Test Et'}
                </button>
                <button type="button" className="btn btn-primary" onClick={handleSalonappySync} disabled={salonappyJob?.running}>
                  {salonappyJob?.running ? 'Aktarılıyor...' : 'Şimdi İçe Aktar'}
                </button>
              </div>

              <div style={{ marginTop: 16, paddingTop: 16, borderTop: '1px solid var(--border)' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 14, marginBottom: 10 }}>
                  <input type="checkbox" checked={branch?.integrations?.salonappy_auto_sync_enabled === true} onChange={e => handleIntegrationChange('salonappy_auto_sync_enabled', e.target.checked)} />
                  Her gün otomatik yeniden aktar (telefon/şifre kaydedilmiş olmalı)
                </label>
                {branch?.integrations?.salonappy_auto_sync_enabled === true && (
                  <div className="grid-2">
                    <div className="form-group">
                      <label className="form-label">Otomatik Aktarım Saati</label>
                      <input type="time" className="input" value={branch?.integrations?.salonappy_auto_sync_time || '03:00'} onChange={e => handleIntegrationChange('salonappy_auto_sync_time', e.target.value)} />
                    </div>
                    <div className="form-group">
                      <label className="form-label">Her Seferinde Kaç Aylık Randevu</label>
                      <select className="select" value={branch?.integrations?.salonappy_auto_sync_months || 3} onChange={e => handleIntegrationChange('salonappy_auto_sync_months', e.target.value === 'skip' ? 'skip' : parseInt(e.target.value, 10))}>
                        <option value={3}>Son 3 ay + gelecek randevular</option>
                        <option value={12}>Son 12 ay + gelecek randevular</option>
                        <option value="skip">Sadece müşterileri aktar</option>
                      </select>
                    </div>
                  </div>
                )}
              </div>

              {salonappyTestResult && (
                <p style={{ marginTop: 10, fontSize: 13, color: salonappyTestResult.ok ? '#10b981' : '#ef4444' }}>{salonappyTestResult.message}</p>
              )}

              {salonappyJob && (
                <div style={{ marginTop: 14, padding: 14, borderRadius: 10, background: 'rgba(255,255,255,0.03)', border: '1px solid var(--border)' }}>
                  <div style={{ fontSize: 13, marginBottom: 6 }}>
                    Durum: <strong>{{
                      starting: 'Başlatılıyor',
                      login: "SalonAppy'ye giriş yapılıyor",
                      fetch_customers: 'Müşteriler çekiliyor',
                      import_customers: 'Müşteriler aktarılıyor',
                      fetch_bookings: 'Randevular çekiliyor',
                      dedupe_bookings: 'Randevular kontrol ediliyor',
                      import_bookings: 'Randevular aktarılıyor',
                      done: 'Tamamlandı',
                      error: 'Hata',
                    }[salonappyJob.phase] || salonappyJob.phase}</strong>
                  </div>
                  {salonappyJob.customersTotal > 0 && (
                    <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Müşteriler: {salonappyJob.customersProcessed}/{salonappyJob.customersTotal}</div>
                  )}
                  {salonappyJob.bookingsTotal > 0 && (
                    <div style={{ fontSize: 12, color: 'var(--text-muted)' }}>Randevular: {salonappyJob.bookingsProcessed}/{salonappyJob.bookingsTotal}</div>
                  )}
                  {!salonappyJob.running && salonappyJob.imported && (
                    <div style={{ fontSize: 13, marginTop: 6 }}>✅ {salonappyJob.imported.customers} müşteri, {salonappyJob.imported.appointments} randevu aktarıldı.</div>
                  )}
                  {salonappyJob.errors?.length > 0 && (
                    <details style={{ marginTop: 8, fontSize: 12, color: '#f59e0b' }}>
                      <summary>{salonappyJob.errors.length} uyarı/hata</summary>
                      <ul style={{ marginTop: 6, paddingLeft: 18 }}>
                        {salonappyJob.errors.slice(0, 10).map((e, i) => <li key={i}>{e}</li>)}
                      </ul>
                    </details>
                  )}
                </div>
              )}
            </div>
          </div>

          <div style={{ marginTop: 20, display: 'flex', justifyContent: 'flex-end' }}>
            <button className="btn btn-primary" onClick={handleSave} disabled={saving}>{saving ? 'Kaydediliyor...' : '💾 Kaydet'}</button>
          </div>
        </div>
      )}

      {section === 'data_sync' && (
        <div className="card glass-card">
          <div className="card-header-icon">
            <span className="icon-badge">🔒</span>
            <h3 className="card-title">Müşteri Verisi Senkronizasyonu (KVKK)</h3>
          </div>
          <p className="card-subtitle-desc">
            Firma müşteri verisinin KENDİ veritabanında da tutulmasını istiyorsa, aşağıya
            firmanın verdiği veritabanı bağlantı bilgilerini girin. Bağlantı aktif edildikten
            sonra mevcut tüm müşteriler ve sonrasındaki her değişiklik birkaç dakika içinde
            otomatik olarak o veritabanına yazılır. Firmanın veritabanı sunucusunun bu
            sunucudan erişilebilir olması gerekir (host/port erişime açık veya IP izinli).
          </p>

          {dataSyncLoading ? (
            <div style={{ color: 'var(--text-muted)' }}>Yükleniyor...</div>
          ) : (
            <>
              <div className="grid-2" style={{ marginBottom: 12 }}>
                <div className="form-group">
                  <label className="form-label">Host</label>
                  <input type="text" className="input" value={dataSyncForm.target_host} onChange={e => handleDataSyncChange('target_host', e.target.value)} placeholder="ör. 185.xx.xx.xx veya db.firma.com" />
                </div>
                <div className="form-group">
                  <label className="form-label">Port</label>
                  <input type="number" className="input" value={dataSyncForm.target_port} onChange={e => handleDataSyncChange('target_port', Number(e.target.value))} />
                </div>
                <div className="form-group">
                  <label className="form-label">Veritabanı Adı</label>
                  <input type="text" className="input" value={dataSyncForm.target_database} onChange={e => handleDataSyncChange('target_database', e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="form-label">Hedef Tablo Adı</label>
                  <input type="text" className="input" value={dataSyncForm.target_table} onChange={e => handleDataSyncChange('target_table', e.target.value)} placeholder="customers" />
                </div>
                <div className="form-group">
                  <label className="form-label">Kullanıcı Adı</label>
                  <input type="text" className="input" value={dataSyncForm.target_username} onChange={e => handleDataSyncChange('target_username', e.target.value)} />
                </div>
                <div className="form-group">
                  <label className="form-label">Şifre {dataSyncSettings ? '(değiştirmek için doldurun, boş bırakılırsa mevcut şifre korunur)' : ''}</label>
                  <input type="password" className="input" value={dataSyncForm.target_password} onChange={e => handleDataSyncChange('target_password', e.target.value)} />
                </div>
              </div>

              <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12, fontSize: 13, color: 'var(--text)' }}>
                <input type="checkbox" checked={dataSyncForm.is_enabled} onChange={e => handleDataSyncChange('is_enabled', e.target.checked)} />
                Senkronizasyon aktif
              </label>

              {dataSyncSettings && (
                <div style={{ fontSize: 12, color: 'var(--text-muted)', marginBottom: 12 }}>
                  Son senkron: {dataSyncSettings.last_synced_at ? new Date(dataSyncSettings.last_synced_at).toLocaleString('tr-TR') : 'Henüz yok'}
                  {dataSyncSettings.consecutive_failure_count > 0 && (
                    <span style={{ color: '#EF4444', marginLeft: 8 }}>⚠️ {dataSyncSettings.consecutive_failure_count} ardışık başarısız deneme — {dataSyncSettings.last_error}</span>
                  )}
                </div>
              )}

              <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginBottom: 12 }}>
                <button className="btn btn-secondary" onClick={handleDataSyncTest} disabled={dataSyncTesting}>{dataSyncTesting ? 'Test ediliyor...' : '🔌 Bağlantıyı Test Et'}</button>
                <button className="btn btn-primary" onClick={handleDataSyncSave} disabled={dataSyncSaving}>{dataSyncSaving ? 'Kaydediliyor...' : '💾 Kaydet'}</button>
                {dataSyncSettings && (
                  <button className="btn btn-secondary" onClick={handleDataSyncBackfill} disabled={dataSyncBackfilling}>{dataSyncBackfilling ? 'Tetikleniyor...' : '🔄 Şimdi Tam Senkronize Et'}</button>
                )}
              </div>

              {dataSyncTestResult && (
                <div style={{ fontSize: 13, color: dataSyncTestResult.ok ? '#10b981' : '#EF4444', marginBottom: 12 }}>
                  {dataSyncTestResult.ok ? '✅ ' : '❌ '}{dataSyncTestResult.message}
                </div>
              )}

              {dataSyncLogs.length > 0 && (
                <details style={{ marginTop: 8 }}>
                  <summary style={{ cursor: 'pointer', fontSize: 13, color: 'var(--text-muted)' }}>Son senkron kayıtları ({dataSyncLogs.length})</summary>
                  <div style={{ marginTop: 8, maxHeight: 240, overflowY: 'auto' }}>
                    {dataSyncLogs.map(log => (
                      <div key={log.id} style={{ fontSize: 12, padding: '6px 0', borderBottom: '1px solid var(--border)', color: log.status === 'success' ? 'var(--text)' : '#EF4444' }}>
                        {new Date(log.created_at).toLocaleString('tr-TR')} — {log.event_type} — {log.status === 'success' ? '✅' : '❌'} {log.error_message}
                      </div>
                    ))}
                  </div>
                </details>
              )}
            </>
          )}
        </div>
      )}

      {section === 'owner_assistant' && (
        <div className="card glass-card">
          <div className="card-header-icon">
            <span className="icon-badge">🤖</span>
            <h3 className="card-title">Ritsa Asist</h3>
          </div>
          <p className="card-subtitle-desc">
            Aşağıya kaydedilen numaradan, işletmeye bildirilen ORTAK Ritsa Asist
            WhatsApp hattına yazıldığında, işletme hakkında (bugün kaç randevu
            var, kaç kişiyle konuşuldu, okunmamış mesaj sayısı vb.) soru sorup
            cevap alınabilecek özel bir asistan devreye girer. Ayrıca her gün
            seçilen saatte otomatik bir "günün özeti" mesajı gönderilir.
          </p>

          <div className="integration-sections">
            <div className="integration-group">
              <div className="grid-2">
                <div className="form-group">
                  <label className="form-label">Sahip WhatsApp Numarası</label>
                  <input type="text" className="input" value={branch?.integrations?.owner_notification_phone || ''} onChange={e => handleIntegrationChange('owner_notification_phone', e.target.value)} placeholder="5xxxxxxxxx" />
                </div>
                <div className="form-group">
                  <label className="form-label">Günlük Özet Saati</label>
                  <input type="time" className="input" value={branch?.integrations?.owner_daily_summary_time || '21:00'} onChange={e => handleIntegrationChange('owner_daily_summary_time', e.target.value)} />
                </div>
              </div>

              <div className="form-group" style={{ marginTop: 8 }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: 8, cursor: 'pointer', fontSize: 14 }}>
                  <input type="checkbox" checked={branch?.integrations?.owner_daily_summary_enabled !== false} onChange={e => handleIntegrationChange('owner_daily_summary_enabled', e.target.checked)} />
                  Her gün otomatik günün özetini gönder
                </label>
              </div>

              <p style={{ fontSize: 13, color: 'var(--text-muted)', marginTop: 12 }}>
                ℹ️ Kaydettikten sonra, sistemin numarayı tanıyabilmesi için bu
                numaradan işletmeye bildirilen ORTAK Ritsa Asist WhatsApp numarasına
                bir mesaj gönderilmeli (örn. "merhaba") — şubenin kendi müşteri
                hattına DEĞİL. Ardından aşağıdan test mesajı gönderilebilir.
              </p>

              <div style={{ display: 'flex', gap: 10, alignItems: 'center', flexWrap: 'wrap', marginTop: 8 }}>
                <button type="button" className="btn btn-secondary" onClick={handleOwnerAssistantTest} disabled={ownerAssistantTesting || !branch?.integrations?.owner_notification_phone}>
                  {ownerAssistantTesting ? 'Gönderiliyor...' : 'Test Mesajı Gönder'}
                </button>
              </div>

              {ownerAssistantTestResult && (
                <p style={{ marginTop: 10, fontSize: 13, color: ownerAssistantTestResult.ok ? '#10b981' : '#ef4444' }}>{ownerAssistantTestResult.message}</p>
              )}
            </div>
          </div>

          <div style={{ marginTop: 20, display: 'flex', justifyContent: 'flex-end' }}>
            <button className="btn btn-primary" onClick={handleSave} disabled={saving}>{saving ? 'Kaydediliyor...' : '💾 Kaydet'}</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default IntegrationsPanel;
